module.exports = __webpack_public_path__ + "static/img/new7-Zr4tLn7V.f3c313e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new7-Zr4tLn7V.png
// module id = urD6
// module chunks = 16